import { QueryClient, DefaultOptions } from '@tanstack/react-query'

const queryConfig: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (previously cacheTime)
  },
  mutations: {
    retry: 0,
  },
}

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
})

export const queryKeys = {
  auth: {
    user: ['auth', 'user'] as const,
    session: ['auth', 'session'] as const,
    perfil: (userId: string) => ['auth', 'perfil', userId] as const,
  },
  eventos: {
    all: ['eventos'] as const,
    list: (filters?: Record<string, unknown>) => ['eventos', 'list', filters] as const,
    detail: (id: string) => ['eventos', 'detail', id] as const,
    inscricoes: (eventoId: string) => ['eventos', 'inscricoes', eventoId] as const,
  },
  ministerios: {
    all: ['ministerios'] as const,
    list: (filters?: Record<string, unknown>) => ['ministerios', 'list', filters] as const,
    detail: (id: string) => ['ministerios', 'detail', id] as const,
    membros: (ministerioId: string) => ['ministerios', 'membros', ministerioId] as const,
  },
  membros: {
    all: ['membros'] as const,
    list: (filters?: Record<string, unknown>) => ['membros', 'list', filters] as const,
    detail: (id: string) => ['membros', 'detail', id] as const,
  },
} as const
